export const frameworkOrigins = {
    'DIGCOMP': {
        language: 'English',
        flag: '🇪🇺',
        fullName: 'Digital Competence Framework for Citizens',
        description: 'A framework that describes the key components of digital competence in terms of knowledge, skills and attitudes',
        scope: 'International',
        country: 'European Union'
    },
    'DIGCOMPEDU': {
        language: 'English',
        flag: '🇪🇺',
        fullName: 'Digital Competence Framework for Educators',
        description: 'A framework that describes the digital competences needed by educators at all levels of education',
        scope: 'International',
        country: 'European Union'
    },
    'PER EN': {
        language: 'Français',
        flag: '🇨🇭',
        fullName: 'Plan d\'études romand - Education numérique',
        description: 'Cadre de référence pour l\'éducation numérique dans la scolarité obligatoire',
        scope: 'Regional',
        country: 'Suisse'
    },
    'LEHRPLAN MI': {
        language: 'Deutsch',
        flag: '🇨🇭',
        fullName: 'Lehrplan 21 - Medien und Informatik',
        description: 'Rahmenlehrplan für Medien und Informatik in der obligatorischen Schule',
        scope: 'Regional',
        country: 'Suisse'
    },
    'RCNUM OBLIGATOIRE': {
        language: 'Français',
        flag: '🇨🇭',
        fullName: 'Référentiel de compétences pour la formation initiale et continue des enseignant.es dans le domaine de l\'éducation numérique - Obligatoire',
        description: 'Cadre de référence pour les compétences numériques des éducateurs dans la scolarité obligatoire de la Conférence intercantonale de l\'instruction publique de la Suisse Romande et du Tessin',
        scope: 'Regional',
        country: 'Suisse'
    },
    'RCNUM POST-OBLIGATOIRE': {
        language: 'Français',
        flag: '🇨🇭',
        fullName: 'Référentiel de compétences pour la formation initiale et continue des enseignant.es dans le domaine de l\'éducation numérique - Post-obligatoire',
        description: 'Cadre de référence pour les compétences numériques des éducateurs dans la formation post-obligatoire de la Conférence intercantonale de l\'instruction publique de la Suisse Romande et du Tessin',
        scope: 'Regional',
        country: 'Suisse'
    },
    'ESCO': {
        language: 'English',
        flag: '🇪🇺',
        fullName: 'European Skills, Competences, Qualifications and Occupations',
        description: 'A classification system for skills, competences, qualifications and occupations',
        scope: 'International',
        country: 'European Union'
    },
    'RCPFPEE': {
        language: 'Français',
        flag: '🇫🇷',
        fullName: 'Référentiel de compétences professionnelles du formateur de personnels enseignants et éducatifs',
        description: 'Cadre de référence pour les compétences professionnelles des formateurs d\'enseignants et des personnels d\'éducation',
        scope: 'National',
        country: 'France'
    },
    'RCPMPE': {
        language: 'Français',
        flag: '🇫🇷',
        fullName: 'Référentiel des compétences professionnelles des métiers du professorat et de l\'éducation',
        description: 'Cadre de référence pour les compétences professionnelles des enseignants et des personnels d\'éducation',
        scope: 'National',
        country: 'France'
    },
    'CRCNEDU': {
        language: 'Français',
        flag: '🇫🇷',
        fullName: 'Cadre de référence des compétences numériques pour l\'éducation',
        description: 'Le CRCN Édu est l\'ensemble des compétences numériques que les enseignants et formateurs doivent acquérir pour enseigner au et par le numérique de manière pertinente.',
        scope: 'National',
        country: 'France'
    },
    'CPLLCD': {
        language: 'English',
        flag: '🇸🇬',
        fullName: 'Learning Outcomes for the Certified Practitioner for Lifelong Learning and Competency Development',
        description: 'A framework that describes the key competencies that must be demonstrated across the four modules of the course',
        scope: 'Institution',
        country: 'Singapore'
    }
};